// noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols

import {GameVariant, int, Nullable} from "./caos-def";


export const VARIANT_FLAG__C1 = 1;
export const VARIANT_FLAG__C2 = 2;
export const VARIANT_FLAG__CV = 4;
export const VARIANT_FLAG__C3 = 8;
export const VARIANT_FLAG__DS = 16;
export const VARIANT_FLAG__SM = 32;


/**
 * Variant setter
 */
export type SetVariantFunc = (variant: Nullable<GameVariant>, unset: boolean) => void;


export const allVariants: GameVariant[] = ["C1", "C2", "CV", "C3", "DS", "SM"];

export function variantArrayToInt(variants: GameVariant[]|number): number {
    if (typeof variants === "number") {
        return variants;
    }
    let out  = 0;
    for (const variant of variants) {
        out |= getVariantFlag(variant);
    }
    return out;
}

export function getVariantFlag(variant: GameVariant): int {
    switch(variant.toUpperCase()) {
        case "C1": return 1;
        case "C2": return 2;
        case "CV": return 4;
        case "C3": return 8;
        case "DS": return 16;
        case "SM": return 32;
        default: return 1024;
    }
}

export function hasVariant(variants: number|GameVariant[], variant: GameVariant): boolean {
    if (typeof variants === "number") {
        return (variants & getVariantFlag(variant)) !== 0;
    }
    return variants.indexOf(variant) >= 0;
}

export function gameName(variant: GameVariant): Nullable<string> {
    switch(variant.toUpperCase()) {
        case "C1": return "Creatures 1";
        case "C2": return "Creatures 2";
        case "CV": return "Creatures Village";
        case "C3": return "Creatures 3";
        case "DS": return "Docking Station";
        case "SM": return "Sea Monkeys";
        default: return null;
    }
}

export function variantsIntersect(variants: number|GameVariant[],  otherVariants: number|GameVariant[]): boolean {

    if (!variants && !otherVariants) {
        return false;
    }

    if (typeof variants !== typeof otherVariants) {
        variants = variantArrayToInt(variants);
        otherVariants = variantArrayToInt(otherVariants)
    }

    if (typeof variants === "number") {
        return variantIntsIntersect(variants, <number>otherVariants);
    } else {
        return variantArraysIntersect(variants, <GameVariant[]>otherVariants);
    }
}

function variantIntsIntersect(variants: number, otherVariants: number): boolean {

    if (variants === 0 || otherVariants === 0) {
        return false
    }

    if (variants == otherVariants) {
        return true;
    }

    let flag = 0;
    for (let i = 0; i < 6; i++) {
        flag = i === 0 ? 1 : (flag * 2);
        if (variants & flag) {
            if (otherVariants & flag) {
                return true
            }
        }
    }
    return false
}

function variantArraysIntersect(variants: GameVariant[], otherVariants: GameVariant[]): boolean {
    if (variants.length === 0 || otherVariants.length === 0) {
        return false;
    }
    for (const variant of variants) {
        if (otherVariants.indexOf(variant) >= 0) {
            return true;
        }
    }
    return false;
}

const _variant_mask_cache: {[mask:number]: GameVariant[]} = {};

export function bitmaskToVariantArray(bitmask: number): GameVariant[] {
    if (typeof _variant_mask_cache[bitmask] !== "undefined") {
        return _variant_mask_cache[bitmask];
    }
    const variants: GameVariant[] = <GameVariant[]>[];
    if (bitmask & VARIANT_FLAG__C1) {
        variants.push("C1");
    }
    if (bitmask & VARIANT_FLAG__C2) {
        variants.push("C2");
    }
    if (bitmask & VARIANT_FLAG__CV) {
        variants.push("CV")
    }
    if (bitmask & VARIANT_FLAG__C3) {
        variants.push("C3")
    }
    if (bitmask & VARIANT_FLAG__DS) {
        variants.push("DS")
    }
    if (bitmask & VARIANT_FLAG__SM) {
        variants.push("SM")
    }
    _variant_mask_cache[bitmask] = <GameVariant[]>variants;
    return variants;
}